import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import AddressForm from '../../../components/forms/addressForm/AddressForm'
import AddressView from '../AddressView'
import { mappingAddressData } from '../../../utils/addressUtil'
import {
  saveAddressWork,
  updateAddressWork,
  saveOrgAddress,
  updateOrgAddress,
} from '../../../redux/actions/address'
import { startLoading, doneLoading } from '../../../utils/loading'
import ButtonPanel from '../../ButtonPanel'
import { PROPOSAL, SUB_PROJECT } from '../../../constants/project'

export default function AddressWork({ schema, isEditAll, handleOnSubmit, ...props }) {
  const { type, isEdit, onChangeIsEdit, showCommandButton, isSubProject, isCompany } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleAddUpdateAddressWork = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        if (isCompany) {
          response = await updateOrgAddress(
            request,
            projectId,
            request.id,
            type,
            isSubProject ? SUB_PROJECT : PROPOSAL
          )
        } else {
          response = await updateAddressWork(
            request,
            projectId,
            request.id,
            type,
            isSubProject ? SUB_PROJECT : PROPOSAL
          )
        }
      } else {
        if (isCompany) {
          response = await saveOrgAddress(
            request,
            projectId,
            type,
            isSubProject ? SUB_PROJECT : PROPOSAL
          )
        } else {
          response = await saveAddressWork(
            request,
            projectId,
            type,
            isSubProject ? SUB_PROJECT : PROPOSAL
          )
        }
      }

      setFormSchema(response)
      onChangeIsEdit(false)
      handleOnSubmit(request)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    const request = mappingAddressData(formSchema, data)
    handleAddUpdateAddressWork(request)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.title}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit && showCommandButton ? (
          <AddressForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          ></AddressForm>
        ) : (
          <div>
            <AddressView data={formSchema} />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.title}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </>
  )
}
